import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  legalConfirmation: {},
  legalConfirmationLoading: false,
};

const slice = createSlice({
  name: 'legalConfirmationSlice',
  initialState,
  reducers: {
    legalConfirmationSlice: (state, { payload }) => {
      state.legalConfirmation = payload;
    },
    legalConfirmationLoadingSlice: (state, { payload }) => {
      state.legalConfirmationLoading = payload;
    },
  },
});

const { actions, reducer } = slice;

export const { legalConfirmationSlice, legalConfirmationLoadingSlice } =
  actions;

export default reducer;
